/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Circle } from 'react-native-svg';

import { IconProps } from '../lib';

function GearSix(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256.00098 256.00098"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M229.645,105.96387,203.69873,91.56055a83.92517,83.92517,0,0,0-6.2876-10.90992l.5-29.68823a103.88966,103.88966,0,0,0-38.17138-22.00146L134.293,44.22949a83.89083,83.89083,0,0,0-12.5918-.01L96.24023,28.94263A103.8856,103.8856,0,0,0,58.10107,50.999l.49952,29.67188A83.85065,83.85065,0,0,0,52.2959,91.5708L26.335,105.98218A103.8963,103.8963,0,0,0,26.3667,150.04L52.313,164.44336a83.92506,83.92506,0,0,0,6.2876,10.90991l-.5,29.68823A103.88954,103.88954,0,0,0,96.272,227.043l25.44678-15.26856a83.89083,83.89083,0,0,0,12.5918.01l25.46093,15.27686a103.88532,103.88532,0,0,0,38.13916-22.0564l-.49951-29.67187a83.79517,83.79517,0,0,0,6.30469-10.8999l25.96094-14.41138A103.8963,103.8963,0,0,0,229.645,105.96387ZM128.00586,176.002a48,48,0,1,1,48-48A47.99987,47.99987,0,0,1,128.00586,176.002Z"
        opacity={0.2}
      />
      <Circle
        cx={128.00586}
        cy={128.00195}
        r={48}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M197.41115,80.65057a83.91167,83.91167,0,0,1,6.28743,10.91L229.64485,105.964a103.88962,103.88962,0,0,1,.03183,44.05764L203.716,164.433a83.91089,83.91089,0,0,1-6.30466,10.90011l.49944,29.67182a103.88963,103.88963,0,0,1-38.13913,22.05638l-25.46093-15.27692a83.91075,83.91075,0,0,1-12.5921-.01L96.27178,227.04288a103.88987,103.88987,0,0,1-38.171-22.00126l.49974-29.68828a83.91167,83.91167,0,0,1-6.28743-10.91005L26.36687,150.0399a103.88946,103.88946,0,0,1-.03183-44.05764L52.29571,91.5709a83.91132,83.91132,0,0,1,6.30467-10.9001L58.10094,50.999A103.88969,103.88969,0,0,1,96.24007,28.94259L121.701,44.21952a83.91075,83.91075,0,0,1,12.5921.00995L159.73994,28.961a103.88959,103.88959,0,0,1,38.171,22.00126Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default GearSix;
